module.exports = __webpack_public_path__ + "static/img/strona_000.e544c781.jpg";